var map = {
	"./capitalitat_footer_logos.png": 52761,
	"./icon-barcelona.svg": 35702,
	"./logo-bcnweb.svg": 13128,
	"./logo_bcn.png": 32203,
	"./logo_capitalitat.png": 11822,
	"./logo_capitalitat_white.png": 60116,
	"./logo_head.png": 270,
	"./logo_head.svg": 14345,
	"./logo_pemb_white.svg": 8909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;